const initialState = {
    liveTrackingData: [],
    historyTrackingData: [],
    vehicleCount:{},
    loadingMap: false,
    errorsMap: {},
    historyTrackingSuccess: false
}

const  mapReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_LIVE_TRACKING_PENDING":
        case "GET_HISTORY_TRACKING_PENDING":
            return { ...state, loadingMap: true, historyTrackingSuccess: false };

        case "GET_LIVE_TRACKING_FULFILLED":
            return {
                ...state,
                loadingMap: false,
                liveTrackingData: action.payload,
                vehicleCount: action.vehicleCount
            };

        case "GET_HISTORY_TRACKING_FULFILLED":
            return {
                ...state,
                loadingMap: false,
                historyTrackingSuccess: action.success,
                historyTrackingData: action.payload,
            };

        case "RESET_DELETE_MAP_STATUS":
            return {
                ...state,
                loadingMap: false,
                changedHydrantStatus: [],
                errorsMap:{}
            };

        case "UPDATE_VEHICLE_LOCATION":
            // Update a single vehicle in the liveTrackingData array using vehicle.id (which is unique)
            let vehicleFound = false;
            const updatedVehicles = state.liveTrackingData.map((vehicle) => {
                // Match by id if available, otherwise match by deviceId + vehicleNumber combination
                const matches = vehicle.id && action.payload.id 
                    ? vehicle.id === action.payload.id
                    : (vehicle.deviceId && action.payload.deviceId && vehicle.deviceId === action.payload.deviceId) &&
                      (vehicle.vehicleNumber && action.payload.vehicleNumber && vehicle.vehicleNumber === action.payload.vehicleNumber);
                
                if (matches) {
                    vehicleFound = true;
                    return { ...vehicle, ...action.payload };
                }
                return vehicle;
            });
            
            // If vehicle not found in array, add it
            if (!vehicleFound) {
                updatedVehicles.push(action.payload);
            }
            
            // Deduplicate array by vehicle.id (primary) or deviceId+vehicleNumber (fallback) to remove any duplicates
            const uniqueVehicles = [];
            const seenIds = new Set();
            const seenDeviceVehicle = new Set();
            
            updatedVehicles.forEach((vehicle) => {
                if (vehicle.id) {
                    // Use id as primary unique identifier
                    if (!seenIds.has(vehicle.id)) {
                        seenIds.add(vehicle.id);
                        uniqueVehicles.push(vehicle);
                    }
                } else if (vehicle.deviceId && vehicle.vehicleNumber) {
                    // Fallback: use deviceId + vehicleNumber combination
                    const comboKey = `${vehicle.deviceId}-${vehicle.vehicleNumber}`;
                    if (!seenDeviceVehicle.has(comboKey)) {
                        seenDeviceVehicle.add(comboKey);
                        uniqueVehicles.push(vehicle);
                    }
                } else {
                    // Last resort: add if no identifier available (shouldn't happen)
                    uniqueVehicles.push(vehicle);
                }
            });
            
            return {
                ...state,
                liveTrackingData: uniqueVehicles
            };

        case "GET_LIVE_TRACKING_REJECTED":
        case "GET_HISTORY_TRACKING_REJECTED":
            return {
                ...state,
                loadingMap: false,
                errorsMap: action.payload
            };

        default:
            return state;
    }
}

export default mapReducer;
